/** Small shared excerpt helper for the batch-templateize dialog rows. */
const POST_EXCERPT_MAX = 140;

export function excerptForBatch(s: string): string {
  const t = (s ?? "").trim();
  if (t.length <= POST_EXCERPT_MAX) return t;
  return `${t.slice(0, POST_EXCERPT_MAX).trimEnd()}…`;
}
